import { Chip } from '@mui/material';
import React from 'react';
import { designTokens } from '@platform-ui/design-system';

export type StatusChipProps = {
  state: string;
  label: string;
  title?: string;
};

const backgroundPalette = {
  default: designTokens.colors.lightContextHigh,
  primary: designTokens.colors.blue400,
  success: designTokens.colors.green500,
  error: designTokens.colors.red500,
  warning: designTokens.colors.yellow300,
  indeterminate: designTokens.colors.coolGray500,
};

export const StatusChip: React.FC<StatusChipProps> = ({
  state,
  label,
  title,
}) => {
  const color = state === 'default' ? 'rgba(0,0,0,0.9)' : 'white';
  return (
    <Chip
      sx={{
        color: color,
        backgroundColor: backgroundPalette[state],
        fontSize: '11px',
        textTransform: 'uppercase',
        height: '20px',
        fontWeight: '600',
        cursor: 'pointer',
      }}
      variant="filled"
      label={label}
      title={title || ''}
    />
  );
};
